const qr = {
  coffin: {
    occupied: {
      coffin: 'El QR de feretro que intenta añadir ya se está utilizando como Qr de féretro en este u otro expediente',
      deceased: 'El QR de feretro que intenta añadir ya se está utilizando como Qr de difunto en este u otro expediente',
      personalitems: 'El QR de feretro que intenta añadir ya se está utilizando como Qr de objetos personales en este u otro expediente',
      urn: 'El QR de feretro que intenta añadir ya se está utilizando como Qr de urna en este u otro expediente',
    },
  },
  coffinQr: 'QR Ataud',
  deceased: {
    occupied: {
      coffin: 'El QR de difunto que intenta añadir ya se está utilizando como Qr de féretro en este u otro expediente',
      deceased: 'El QR de difunto que intenta añadir ya se está utilizando como Qr de difunto en este u otro expediente',
      personalitems: 'El QR de difunto que intenta añadir ya se está utilizando como Qr de objetos personales en este u otro expediente',
      urn: 'El QR de difunto que intenta añadir ya se está utilizando como Qr de urna en este u otro expediente',
    },
  },
  occupied: {
    coffin: 'El QR de feretro ya se ha utilizado en este o en otro expediente',
    deceased: 'El QR de pulsera ya se ha utilizado en este u otro expediente.',
    personalitems: 'El QR de objetos personales ya se ha utilizado en este u otro expediente.',
    urn: 'El QR de urna ya se ha utilizado en este o en otro expediente.',
  },
  personalitems: {
    occupied: {
      coffin: 'El QR de objetos personales que intenta añadir ya se está utilizando como Qr de féretro en este u otro expediente',
      deceased: 'El QR de objetos personales que intenta añadir ya se está utilizando como Qr de difunto en este u otro expediente',
      personalitems: 'El QR de objetos personales que intenta añadir ya se está utilizando como Qr de objetos personales en este u otro expediente',
      urn: 'El QR de objetos personales que intenta añadir ya se está utilizando como Qr de urna en este u otro expediente',
    },
  },
  personalItemsQr: 'QR objetos personales',
  qr: 'QR Pulsera',
  search: 'Buscar consultas',
  title: 'Consultas',
  urn: {
    occupied: {
      coffin: 'El QR de urna que intenta añadir ya se está utilizando como Qr de féretro en este u otro expediente',
      deceased: 'El QR de urna que intenta añadir ya se está utilizando como Qr de difunto en este u otro expediente',
      personalitems: 'El QR de urna que intenta añadir ya se está utilizando como Qr de objetos personales en este u otro expediente',
      urn: 'El QR de urna que intenta añadir ya se está utilizando como Qr de urna en este u otro expediente',
    },
  },
  urnQr: 'QR Urna',
};

export default qr;
